import script from "./dept_center.vue?vue&type=script&setup=true&lang=js"
export * from "./dept_center.vue?vue&type=script&setup=true&lang=js"

import "./dept_center.vue?vue&type=style&index=0&id=ea56672e&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\baoda\\salary\\wages-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea56672e"]])

export default __exports__